import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  discardContractDialogSpinner: {
    marginLeft: pxToRem(20),
  },
  textColorError: {
    color: theme.palette.accentError,
  },
});
